import React from "react";
import clsx from "clsx";

import { ReactComponent as ArrowRightSingleIcon } from "../../assets/svg/arrow_right_single.svg";
import { IActionListLesson, ILessonByTeachingMaterial } from "../../state";

import styles from "./LessonAccordion.module.scss";

type Props = {
  lesson: ILessonByTeachingMaterial;
  roundNo: number;
  isLeaf: boolean;
  children: React.ReactNode;
  actionLesson?: IActionListLesson;
};

const LessonAccordion: React.FC<Props> = ({
  lesson,
  roundNo,
  isLeaf,
  actionLesson,
  children,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <div className={styles.accordionBlock}>
      <div
        className={styles.accordionHeader}
        onClick={() => setIsOpen(prev => !prev)}
      >
        <ArrowRightSingleIcon
          className={clsx(styles.accordionArrow, isOpen && styles.open)}
        />
        <span>
          {isLeaf
            ? lesson.rounds.length > 1
              ? `実践ワークシート (${roundNo})`
              : "実践ワークシート"
            : `${lesson.name} ${lesson.title}`}
        </span>
      </div>
      {isOpen && (
        <div className={styles.accordionContent}>
          {children}
          {actionLesson?.reflection_realization_reference && (
            <div className={styles.actionListBlock}>
              <p className={styles.actionListTitle}>行動した内容と気づき</p>
              <div className={styles.actionListInner}>
                <div className={styles.actionListItem}>
                  <p className={styles.actionListContent}>
                    {actionLesson.reflection_realization_reference.content}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LessonAccordion;
